import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CacheState {
    churchToolsServices: string[];
}

const initialState: CacheState = {
    churchToolsServices: [],
};

/**
 * Slice to store derived data from API responses
 * This gets populated automatically when agenda data is fetched
 */
const cacheSlice = createSlice({
    name: 'cache',
    initialState,
    reducers: {
        addChurchToolsServices: (state, action: PayloadAction<string[]>) => {
            state.churchToolsServices = [
                ...new Set([...state.churchToolsServices, ...action.payload]),
            ];
        },
        clearChurchToolsServices: (state) => {
            state.churchToolsServices = [];
        },
    },
});

export const { addChurchToolsServices, clearChurchToolsServices } = cacheSlice.actions;
export default cacheSlice.reducer;
